(() => {
  'use strict';
  if (window.LLProductRails) return;
  const selector = '[data-ll-product-rail]';
  const instances = new Map();
  const mount = root => {
    if (instances.has(root)) return;
    const scroller = root.querySelector('.grid-overflow-wrapper');
    const track = scroller?.querySelector('.CollectionSection-slider');
    const controls = root.querySelector('.ll-row-controls');
    const previous = root.querySelector('.ll-row-prev');
    const next = root.querySelector('.ll-row-next');
    if (!scroller || !track || !controls || !previous || !next) return;
    const events = new AbortController();
    const options = {signal: events.signal};
    let frame = 0;
    const refresh = () => {
      frame = 0;
      if (!root.isConnected) return;
      const count = track.querySelectorAll(':scope > .grid__item').length;
      root.style.setProperty('--ll-rail-card-count', Math.max(1, count));
      const maximum = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const position = Math.min(maximum, Math.abs(scroller.scrollLeft));
      controls.hidden = count < 1;
      previous.disabled = position < 4;
      next.disabled = position >= maximum - 4;
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(refresh);
    };
    const move = direction => {
      const rtl = getComputedStyle(scroller).direction === 'rtl';
      scroller.scrollBy({
        left: direction * scroller.clientWidth * (rtl ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
    previous.addEventListener('click', () => move(-1), options);
    next.addEventListener('click', () => move(1), options);
    scroller.addEventListener('scroll', schedule, {passive: true, signal: events.signal});
    scroller.addEventListener('load', schedule, {capture: true, signal: events.signal});
    window.addEventListener('resize', schedule, options);
    window.addEventListener('pageshow', schedule, options);
    const sizes = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    sizes?.observe(scroller);
    sizes?.observe(track);
    const cards = new MutationObserver(schedule);
    cards.observe(track, {childList: true});
    instances.set(root, () => {
      events.abort();
      sizes?.disconnect();
      cards.disconnect();
      if (frame) cancelAnimationFrame(frame);
      instances.delete(root);
    });
    refresh();
    schedule();
  };
  const roots = scope => {
    const result = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) result.unshift(scope);
    return result;
  };
  const scan = (scope = document) => {
    for (const [root, dispose] of instances) if (!root.isConnected) dispose();
    for (const root of roots(scope)) mount(root);
  };
  const unload = event => {
    for (const [root, dispose] of instances) {
      if (event.target === root || event.target.contains(root)) dispose();
    }
  };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', unload);
  document.addEventListener('page:loaded', () => scan());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), {once: true});
  else scan();
  window.LLProductRails = {scan};
})();
